import type { ProgressStatus } from '@jotta/types/IO'
import { cn } from '@jotta/utils/css'
import { filesize } from '@jotta/utils/filesize'
import type { FC } from 'react'
import { formatBytes } from '@jotta/utils/formatStorage'

export interface ProgressBarProps extends Partial<ProgressStatus> {
  className?: string
}
export const ProgressBar: FC<
  ProgressBarProps & {
    variant?: 'danger' | 'black'
  }
> = ({ className, completed, total, variant }) => {
  const percentComplete =
    completed !== undefined && total !== undefined && total > 0
      ? Math.round((completed / total) * 100)
      : 0
  return (
    <div
      className={cn(
        'relative h-3 w-full overflow-clip rounded-full bg-grey6',
        className,
      )}
    >
      <div
        className={cn('h-full bg-input-control', {
          'bg-danger-fg': variant === 'danger',
          'bg-black': variant === 'black',
        })}
        style={{
          width: `${percentComplete}%`,
        }}
      />
    </div>
  )
}

export const StorageProgressBar: FC<ProgressBarProps> = ({
  className,
  completed,
  total,
  ...rest
}) => (
  <div className={cn('flex flex-col items-start gap-1', className)}>
    <ProgressBar
      completed={completed}
      total={total}
      variant={
        completed && total && completed / total > 0.9 ? 'danger' : 'black'
      }
      {...rest}
    />
    <div className="body-sm-sh flex gap-1">
      {completed !== undefined && <span>{formatBytes(completed)}</span>}
      {completed !== undefined && total !== undefined && <span>/</span>}
      {total !== undefined && <span>{formatBytes(total)}</span>}
    </div>
  </div>
)
